module.exports = __webpack_public_path__ + "static/media/Test34.669419f2.bmp";